















































































import Vue from "vue";
import KassenbuchPopover, { KassenbuchUpdateEvent } from "./KassenbuchPopover.vue";
import KassenbuchUebersichtContextMenu, { MenuItemSelected } from "./KassenbuchUebersichtContextMenu.vue";
import { default as moment, Moment } from "moment-timezone";
import { forkJoin, of, Observable } from "rxjs";
import { exhaustMap, flatMap, groupBy, map, mergeMap, reduce, switchMap, toArray } from "rxjs/operators";
import { Studio } from "@/api/Studio";
import { currentTimestamp, PopoverMode, sortStringsAlnum } from "@/api/Termine";
import { AbrechnungTag, Ausgabe, Einnahme, Kassenbuch, Transaktion } from "@/api/Abrechnung";
import { getStudioKuerzel } from "@/api/http";
import { createKassenbuchDruckansicht } from "@/api/Reporting";
import { format } from "@/api/reporting/util";
export default Vue.extend({
  name: "KassenbuchUebersicht",
  components: {
    KassenbuchUebersichtContextMenu,
    KassenbuchPopover,
  },
  props: {
    monat: {
      type: Number,
      required: true,
    },
    jahr: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      zeit: currentTimestamp(),
      studios: [] as Studio[],
      kassenbuch: {} as Kassenbuch,
      transaktionen: [] as Transaktion[],
      saldoVormonat: 0,
      summeEinnahmen: 0,
      summeAusgaben: 0,
      //damen: [] as MonatsabschlussZeile[],
      //summe: {} as MonatsabschlussZeile,
    };
  },
  created() {
    this.zeit = currentTimestamp();
  },
  mounted() {
    this.zeit.month(this.monat).year(this.jahr);
    this.updateData();
  },
  watch: {
    monat() {
      console.log('Neuer Monat:', this.monat);
      this.zeit.month(this.monat);
      this.updateData();
    },
    jahr() {
      console.log('Neues Jahr:', this.jahr);
      this.zeit.year(this.jahr);
      this.updateData();
    },
  },
  computed: {
    monatFormatiert(): string {
      this.monat; // Hack to trigger re-evaluation, see https://logaretm.com/blog/2019-10-11-forcing-recomputation-of-computed-properties
      return this.zeit.format("YYYY-MM");
    },
  },
  methods: {
    updateData() {
      this.$store.dispatch("appLoading", true);

      this.studios = this.$store.getters["studios"];
      const studioSort = {'Gi-Gu': 1, 'DA': 2, 'GG': 3, 'WI': 4} as {[studio: string]: number};
      //const studioSort = this.studios.reduce((agg, cur) => { agg[getStudioKuerzel(cur.bezeichner)] = cur.nummernkreis; return agg; }, {} as {[studio: string]: number});

      const getLetztenTagDerWoche = (tag: number) => {
        const wochenIndex = Math.floor((tag - 1) / 7);
        let letzterTag;
        if (wochenIndex <= 3) {
          letzterTag = wochenIndex * 7 + 7;
        } else {
          letzterTag = moment(this.zeit).daysInMonth();
        }
        //console.log(`${tag} => ${letzterTag}`)
        return letzterTag;
      };

      const _this = this as any;
      forkJoin(
        this.$znaApi.getKassenbuch(this.zeit),
        this.$znaApi.getKassenbuch(moment(this.zeit).subtract(1, 'month')),
        this.$znaApi.getKassenbuchEinnahmen(this.zeit).pipe(
          flatMap(monatsabschluesse => {
            return monatsabschluesse
              .flatMap(monatsabschluss => {
                const studioId = parseInt((monatsabschluss.monat_studio as string).substring(8));
                const studio = getStudioKuerzel(this.studios.filter(studio => studio.id == studioId)[0].bezeichner);
                return (monatsabschluss.tage as AbrechnungTag[]).map(einnahme => ({
                  studio: studio,
                  tag: parseInt(einnahme.buchungstag),
                  einnahme: einnahme.miete,
                  steuer: einnahme.steuer,
                } as Einnahme))
              });
            }),
          groupBy(einnahme => getLetztenTagDerWoche(einnahme.tag) + '_' + einnahme.studio),
          mergeMap(group => group.pipe(
            reduce((acc, current) => {
              acc.tag = parseInt(group.key.split('_')[0]);
              acc.studio = group.key.split('_')[1];
              acc.einnahme += current.einnahme;
              acc.steuer += current.steuer;
              return acc;
            }),
          )),
          toArray(),
        ),
      ).pipe(
        mergeMap(([kassenbuch, kassenbuchVormonat, einnahmen]) => {
          const transaktionen = ([...einnahmen.map(e => Object.assign(e, {typ: 'einnahme'})), ...kassenbuch.ausgaben.map(a => Object.assign(a, {typ: 'ausgabe'}))] as Transaktion[]).sort((tx1, tx2) => {
            // Sortiere Monnatseinnahmen (1) nach Ende-der-Woche-Tag, (2) nach Typ und (3a) nach Studio-Nummernkreis, bzw. (3b) nach Belegnummer
            const byDay = tx1.tag - tx2.tag;
            if (byDay != 0) return byDay;
            if (tx1.typ != tx2.typ) return sortStringsAlnum(tx2.typ, tx1.typ); // Erst Einnahmen, dann Ausgaben
            switch (tx1.typ) {
              case 'einnahme': return studioSort[(tx1 as Einnahme).studio]   - studioSort[(tx2 as Einnahme).studio];
              case 'ausgabe' : return           ((tx1 as Ausgabe).beleg||99) -           ((tx2 as Ausgabe).beleg||99);
              default: return 0;
            }
          });
          const summeEinnahmen = einnahmen.reduce((zwischensumme, einnahme) => zwischensumme + einnahme.einnahme + einnahme.steuer, 0);
          const summeAusgaben = kassenbuch.ausgaben.reduce((zwischensumme, ausgabe) => zwischensumme + ausgabe.betrag, 0);
          let newKassenbuchObservable = of(kassenbuch);
          if (kassenbuchVormonat.saldo) {
            const neuerSaldo = Math.round((kassenbuchVormonat.saldo + summeEinnahmen - summeAusgaben) * 100) / 100;
            const aktuellerSaldoKorrekt = Math.abs(kassenbuch.saldo - neuerSaldo) < 0.01;
            if (!aktuellerSaldoKorrekt) {
              console.log('Erkannt, dass Saldo nicht stimmt!');
              console.log(`Saldo Vormonat = ${kassenbuchVormonat.saldo}`);
              console.log(`Summe Einnahmen = ${summeEinnahmen}`);
              console.log(`Summe Ausgaben  = ${summeAusgaben}`);
              console.log(`Neuer Saldo müsste sein: ${neuerSaldo}`);
              kassenbuch.saldo = neuerSaldo;
              newKassenbuchObservable = _this.$znaApi.updateKassenbuch(this.zeit, kassenbuch).pipe(
                  switchMap(signal => _this.$znaApi.getKassenbuch(this.zeit)
                ));
            }
          }
          return forkJoin(
            newKassenbuchObservable,
            of(kassenbuchVormonat),
            of(transaktionen),
            of(summeEinnahmen),
            of(summeAusgaben)
          );
        }),
      ).subscribe(([kassenbuch, kassenbuchVormonat, transaktionen, summeEinnahmen, summeAusgaben]) => {
        this.kassenbuch = kassenbuch;
        this.transaktionen = transaktionen;
        this.saldoVormonat = kassenbuchVormonat.saldo;
        this.summeEinnahmen = summeEinnahmen;
        this.summeAusgaben = summeAusgaben;
        console.log(kassenbuch);
        console.log(kassenbuchVormonat);
        console.log(_this.summeEinnahmen);
        console.log(_this.summeAusgaben);
        console.log(_this.saldoVormonat);
        this.$store.dispatch("appLoading", false);
      },
      (error: any) => {
        this.$toast.add({
          severity: "error",
          summary: "Laden der Daten fehlgeschlagen",
          detail: error,
          life: 3000,
        });
        this.$store.dispatch("appLoading", false);
      });
    },
    format(betrag: number, printZeros = false): string {
      return format(betrag, printZeros, 2);
    },
    createKassenbuchDruckansicht() {
      createKassenbuchDruckansicht(
        (this as any).zeit,
        (this as any).transaktionen,
        (this as any).kassenbuch,
        (this as any).saldoVormonat
      ).then((pdfDocument) => {
        // Siehe https://pdfmake.github.io/docs/getting-started/client-side/methods/
        // pdfDocument.download();
        pdfDocument.open();
        /*
        pdfDocument.getDataUrl((dataUrl) => {
          const targetElement = document.querySelector("#iframeContainer");
          const iframe = document.createElement("iframe");
          iframe.src = dataUrl;
          targetElement.appendChild(iframe);
        });
        */
      });
    },
    openContextMenu(transaktion: Transaktion) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        const e = event as MouseEvent;
        if (!transaktion) {
          //transaktion = this.getTransaktionFromCoordinates(e);
        }
        if (transaktion && transaktion.tag) {
          //const zeitslot = this.getZeitslot(e);
          //console.debug("Klick war auf folgender Transaktion:");
          //console.debug(transaktion);
          /*
          console.debug("Klick war auf folgender Stunde:");
          console.debug(zeitslot);
          */
          const contextMenu = this.$refs.contextMenu as any;
          contextMenu.open(transaktion);
        }
      }
    },
    onMenuItemSelected(selectedEvent: MenuItemSelected) {
      this.showDialog(
        selectedEvent.popoverMode,
        selectedEvent.transaktion
      );
    },
    editOrCreate(transaktion?: Transaktion) {
      this.showDialog(
        (transaktion?.typ == 'ausgabe' ? 'edit' : 'create') as PopoverMode,
        transaktion
      );
    },
    showDialog(
      popoverMode: PopoverMode,
      transaktion?: Transaktion
    ) {
      console.debug(event);
      const popover: any = this.$refs.popover;
      const nextBelegNr = this.transaktionen
        .filter(tx => tx.typ == "ausgabe")
        .map(tx => (tx as Ausgabe).beleg || 0)
        .reduce((agg, curr) => Math.max(agg || 0, curr || 0), 0) + 1;
      this.$nextTick(() => popover.show(popoverMode, nextBelegNr, this.zeit.format('.MM.YYYY'), transaktion));
    },
    ausgabeUpdated(kassenbuchUpdateEvent: KassenbuchUpdateEvent) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      console.log(kassenbuchUpdateEvent);
      const alteAusgabe = kassenbuchUpdateEvent.alteAusgabe;
      const ausgabe = kassenbuchUpdateEvent.ausgabe;
      let idx = -1;
      let updateData = false;
      switch (kassenbuchUpdateEvent.popoverMode) {
        case "delete":
          idx = this.kassenbuch.ausgaben.indexOf(alteAusgabe);
          console.log("Lösche Tx an Index " + idx);
          if (idx >= 0) {
            this.kassenbuch.ausgaben.splice(idx, 1);
            updateData = true;
          }
          break;

        case "create":
          this.kassenbuch.ausgaben.push(ausgabe);
          this.kassenbuch.ausgaben.sort((a1, a2) => a1.tag - a2.tag);
          updateData = true;
          break;

        case "edit":
          idx = this.kassenbuch.ausgaben.indexOf(alteAusgabe);
          console.log("Ersetze Tx an Index " + idx);
          if (idx >= 0) {
            this.kassenbuch.ausgaben.splice(idx, 1, ausgabe);
            this.kassenbuch.ausgaben.sort((a1, a2) => a1.tag - a2.tag);
            updateData = true;
          }
          break;
      }

      if (updateData) {
        this.$store.dispatch("appLoading", true);
        this.$znaApi.updateKassenbuch(this.zeit, this.kassenbuch).subscribe(_ => this.updateData());
      }
    },
  },
});
